import { render, staticRenderFns } from "./CustomOrderCart.vue?vue&type=template&id=6ee860f6&scoped=true"
import script from "./CustomOrderCart.vue?vue&type=script&lang=js"
export * from "./CustomOrderCart.vue?vue&type=script&lang=js"
import style0 from "./CustomOrderCart.vue?vue&type=style&index=0&id=6ee860f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee860f6",
  null
  
)

export default component.exports